import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/FileCopy";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

import { CatalogGrade } from "@/pages/steel/models/CatalogGrade";

type Props = {
	setSelectedRowData: (grade: CatalogGrade) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	handleNewGrade: Function;
};
export const useGradeOptionsFunctions = ({
	setSelectedRowData,
	setShowModal,
	handleNewGrade,
}: Props) => {
	const getMenuOptions = (data: CatalogGrade) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Grade",
				key: "new_grade",
				onClick: () => {
					handleNewGrade();
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Edit Grade",
					key: "edit_grade",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("update");
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Grade",
					key: "delete_grade",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("delete");
					},
					icon: <DeleteIcon />,
				},
				{
					name: "Duplicate Grade",
					key: "duplicate_grade",
					onClick: () => {
						setSelectedRowData({
							...data,
							GradeName: `${data.GradeName} (Copy)`,
							IsDuplicate: true,
						});
						setShowModal("create");
					},
					icon: <ContentCopyIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
